"use strict";

var _regeneratorRuntime = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/regenerator/index.js");

var _toConsumableArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEcommerce = exports.EcommerceProvider = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var frontend_common_1 = require("@ryerson/frontend.common");

var Models_1 = require("./Models");

var frontend_application_1 = require("@ryerson/frontend.application");

var AddToCart_1 = require("./AddToCart");

var common_permissions_1 = require("@ryerson/common.permissions");

var common_enums_1 = require("@ryerson/common.enums");

var mappers_1 = require("./mappers"); // CONTEXT


var EcommerceContext = react_1.default.createContext({}); // PROVIDER

var EcommerceProvider = function EcommerceProvider(_ref) {
  var children = _ref.children,
      shippingAndBillingState = _ref.shippingAndBillingState,
      cartPricingState = _ref.cartPricingState;

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      isMounted = _ref3[0],
      setIsMounted = _ref3[1];

  var _ref4 = (0, react_1.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      zipCodeTrigger = _ref5[0],
      setZipCodeTrigger = _ref5[1];

  var _ref6 = (0, frontend_application_1.useApplication)(),
      user = _ref6.user,
      axiosInstance = _ref6.axiosInstance,
      zipCode = _ref6.zipCode,
      profile = _ref6.profile,
      localization = _ref6.localization,
      setZipCode = _ref6.setZipCode,
      isGuestUser = _ref6.isGuestUser,
      zipCodeSystemUpdate = _ref6.zipCodeSystemUpdate,
      setZipCodeSystemUpdate = _ref6.setZipCodeSystemUpdate;

  var _ref7 = (0, react_1.useState)(function () {
    var defaultCheckoutType = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.checkoutType);
    return defaultCheckoutType || Models_1.CheckOutType.CART;
  }),
      _ref8 = _slicedToArray(_ref7, 2),
      checkoutType = _ref8[0],
      setCheckoutType = _ref8[1];

  var _ref9 = (0, react_1.useState)(function () {
    var defaultShipToAddressPage = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.shipToAddressPage);
    return defaultShipToAddressPage || Models_1.ShipToAddressPage.ACCOUNT_SETTINGS;
  }),
      _ref10 = _slicedToArray(_ref9, 2),
      shipToAddressPage = _ref10[0],
      setShipToAddressPage = _ref10[1];

  var _ref11 = (0, react_1.useState)(function () {
    var defaultSelectedShipToAddress = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.selectedShipToAddress);
    return defaultSelectedShipToAddress && JSON.parse(defaultSelectedShipToAddress) || {};
  }),
      _ref12 = _slicedToArray(_ref11, 2),
      selectedShipToAddress = _ref12[0],
      setSelectedShipToAddress = _ref12[1];

  var _ref13 = (0, react_1.useState)(function () {
    var defaultCartDeliveryTimesData = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.cartDeliveryTimesData);
    return defaultCartDeliveryTimesData && JSON.parse(defaultCartDeliveryTimesData) || [];
  }),
      _ref14 = _slicedToArray(_ref13, 2),
      cartDeliveryTimesData = _ref14[0],
      setCartDeliveryTimesData = _ref14[1];

  var _ref15 = (0, react_1.useState)(function () {
    var defaultShipToNumber = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quoteShipToNumber);
    return defaultShipToNumber || "";
  }),
      _ref16 = _slicedToArray(_ref15, 2),
      quoteShipToNumber = _ref16[0],
      setQuoteShipToNumber = _ref16[1];

  var _ref17 = (0, react_1.useState)(function () {
    var defaultQuoteId = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quoteId);
    return defaultQuoteId || "";
  }),
      _ref18 = _slicedToArray(_ref17, 2),
      quoteId = _ref18[0],
      setQuoteId = _ref18[1];

  var _ref19 = (0, react_1.useState)(function () {
    var defaultQuoteName = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quoteNameForCheckout);
    return defaultQuoteName || "";
  }),
      _ref20 = _slicedToArray(_ref19, 2),
      quoteNameForCheckout = _ref20[0],
      setQuoteNameForCheckout = _ref20[1];

  var _ref21 = (0, react_1.useState)(function () {
    var defaultQuoteSource = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quoteSourceForCheckout);
    return defaultQuoteSource || "";
  }),
      _ref22 = _slicedToArray(_ref21, 2),
      quoteSourceForCheckout = _ref22[0],
      setQuoteSourceForCheckout = _ref22[1];

  var _ref23 = (0, react_1.useState)(function () {
    var defaultQuoteCart = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quoteCart);
    return defaultQuoteCart && JSON.parse(defaultQuoteCart) || {};
  }),
      _ref24 = _slicedToArray(_ref23, 2),
      quoteCart = _ref24[0],
      setQuoteCart = _ref24[1];

  var _ref25 = (0, react_1.useState)(function () {
    var defaultQuoteCartPricingData = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quoteCartPricingData);
    return defaultQuoteCartPricingData && JSON.parse(defaultQuoteCartPricingData) || {};
  }),
      _ref26 = _slicedToArray(_ref25, 2),
      quoteCartPricingData = _ref26[0],
      setQuoteCartPricingData = _ref26[1];

  var _ref27 = (0, react_1.useState)(function () {
    var defaultQuoteListForCheckout = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quoteListForCheckout);
    return defaultQuoteListForCheckout && JSON.parse(defaultQuoteListForCheckout) || {};
  }),
      _ref28 = _slicedToArray(_ref27, 2),
      quoteListForCheckout = _ref28[0],
      setQuoteListForCheckout = _ref28[1];

  var _ref29 = (0, react_1.useState)(function () {
    var storedQuotePurchaseOrderNumber = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quotePurchaseOrderNumber);
    return storedQuotePurchaseOrderNumber && storedQuotePurchaseOrderNumber || "";
  }),
      _ref30 = _slicedToArray(_ref29, 2),
      quotePurchaseOrderNumber = _ref30[0],
      setQuotePurchaseOrderNumber = _ref30[1];

  var _ref31 = (0, react_1.useState)(function () {
    var storedQuotePaymentInformation = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.quotePaymentInformation);
    return storedQuotePaymentInformation && JSON.parse(storedQuotePaymentInformation) || {};
  }),
      _ref32 = _slicedToArray(_ref31, 2),
      quotePaymentInformation = _ref32[0],
      setQuotePaymentInformation = _ref32[1];

  var _ref33 = (0, react_1.useState)(function () {
    var storedCustomerPickup = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.customerPickup);
    return storedCustomerPickup && JSON.parse(storedCustomerPickup) || false;
  }),
      _ref34 = _slicedToArray(_ref33, 2),
      customerPickup = _ref34[0],
      setCustomerPickup = _ref34[1];

  var _ref35 = (0, react_1.useState)(function () {
    var storedPurchaseOrderNumber = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.purchaseOrderNumber);
    return storedPurchaseOrderNumber && storedPurchaseOrderNumber || "";
  }),
      _ref36 = _slicedToArray(_ref35, 2),
      purchaseOrderNumber = _ref36[0],
      setPurchaseOrderNumber = _ref36[1];

  var _ref37 = (0, react_1.useState)(function () {
    var storedDiscountCode = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.discountCode);
    return storedDiscountCode && storedDiscountCode || "";
  }),
      _ref38 = _slicedToArray(_ref37, 2),
      discountCode = _ref38[0],
      setDiscountCode = _ref38[1];

  var _ref39 = (0, frontend_common_1.useLocalStorage)(frontend_common_1.LocalItems.addToCart, []),
      _ref40 = _slicedToArray(_ref39, 2),
      shoppingCartData = _ref40[0],
      setShoppingCartData = _ref40[1];

  var _ref41 = (0, react_1.useState)({}),
      _ref42 = _slicedToArray(_ref41, 2),
      shoppingCart = _ref42[0],
      setShoppingCart = _ref42[1];

  var _ref43 = (0, react_1.useState)(function () {
    var storedCartPricingData = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.cartPricingData);
    return storedCartPricingData && JSON.parse(storedCartPricingData) || cartPricingState || {};
  }),
      _ref44 = _slicedToArray(_ref43, 2),
      cartPricingData = _ref44[0],
      setCartPricingData = _ref44[1];

  var _ref45 = (0, react_1.useState)(function () {
    var storedShippingAndBillingInformation = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.shippingAndBillingInformation);
    return storedShippingAndBillingInformation && JSON.parse(storedShippingAndBillingInformation) || shippingAndBillingState || {};
  }),
      _ref46 = _slicedToArray(_ref45, 2),
      shippingAndBillingInformation = _ref46[0],
      setShippingAndBillingInformation = _ref46[1];

  var _ref47 = (0, react_1.useState)(function () {
    var storedDefaultShipToAddress = (0, frontend_common_1.getLocalItem)(frontend_common_1.SessionItems.defaultShipToAddress);
    return storedDefaultShipToAddress && JSON.parse(storedDefaultShipToAddress) || {};
  }),
      _ref48 = _slicedToArray(_ref47, 2),
      defaultShipToAddress = _ref48[0],
      setDefaultShipToAddress = _ref48[1];

  var _ref49 = (0, react_1.useState)(false),
      _ref50 = _slicedToArray(_ref49, 2),
      searchAddedToCart = _ref50[0],
      setSearchAddedToCart = _ref50[1];
  /**
  * onStorageUpdate
  *
  * @remarks
  Event handler for storage update: used fore sync across tabs
  */


  var onStorageUpdate = function onStorageUpdate(e) {
    var key = e.key,
        newValue = e.newValue;
    var newValueObject = (newValue === null || newValue === void 0 ? void 0 : newValue.includes("}")) ? JSON.parse(newValue) : undefined;

    if (key === frontend_common_1.SessionItems.defaultShipToAddress) {
      newValueObject && setDefaultShipToAddress(newValueObject);
    }
  };

  (0, react_1.useEffect)(function () {
    if (typeof window !== "undefined" && isMounted) {
      window.addEventListener("storage", onStorageUpdate);
    }

    return function () {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, [isMounted]);

  var _ref51 = (0, react_1.useState)(function () {
    var storedShipToAddresses = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.shipToAddresses);
    return storedShipToAddresses && JSON.parse(storedShipToAddresses) || [];
  }),
      _ref52 = _slicedToArray(_ref51, 2),
      shipToAddresses = _ref52[0],
      setShipToAddresses = _ref52[1];

  var _ref53 = (0, react_1.useState)(function () {
    var storedFlexibleDelivery = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.flexibleDelivery);
    return storedFlexibleDelivery && JSON.parse(storedFlexibleDelivery) || false;
  }),
      _ref54 = _slicedToArray(_ref53, 2),
      flexibleDelivery = _ref54[0],
      setFlexibleDelivery = _ref54[1];

  var _ref55 = (0, react_1.useState)(function () {
    var storedOrderConfirmationDetail = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.orderConfirmationDetail);
    return storedOrderConfirmationDetail && JSON.parse(storedOrderConfirmationDetail) || {};
  }),
      _ref56 = _slicedToArray(_ref55, 2),
      orderConfirmationDetail = _ref56[0],
      setOrderConfirmationDetail = _ref56[1];

  var _ref57 = (0, react_1.useState)(function () {
    var storeSalesPlant = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.salesPlant);
    return storeSalesPlant && JSON.parse(storeSalesPlant) || {};
  }),
      _ref58 = _slicedToArray(_ref57, 2),
      salesPlant = _ref58[0],
      setSalesPlant = _ref58[1];

  var _ref59 = (0, react_1.useState)(function () {
    var storeIsValidZipCode = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.isValidZipCode);
    return storeIsValidZipCode && JSON.parse(storeIsValidZipCode) || true;
  }),
      _ref60 = _slicedToArray(_ref59, 2),
      isValidZipCode = _ref60[0],
      setIsValidZipCode = _ref60[1];

  var _ref61 = (0, react_1.useState)(false),
      _ref62 = _slicedToArray(_ref61, 2),
      showMergeCartModal = _ref62[0],
      setShowMergeCartModal = _ref62[1];

  var _ref63 = (0, react_1.useState)(0),
      _ref64 = _slicedToArray(_ref63, 2),
      numberOfItems = _ref64[0],
      setNumberOfItems = _ref64[1];

  var _ref65 = (0, react_1.useState)(function () {
    var storeIsCartDeliverable = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.isCartDeliverable);
    return storeIsCartDeliverable && JSON.parse(storeIsCartDeliverable) || true;
  }),
      _ref66 = _slicedToArray(_ref65, 2),
      isCartDeliverable = _ref66[0],
      setIsCartDeliverable = _ref66[1];

  var _react_1$default$useS = react_1.default.useState(function () {
    var storedBankAccount = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.bankAccount);
    return storedBankAccount && JSON.parse(storedBankAccount) || [];
  }),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      bankAccounts = _react_1$default$useS2[0],
      setBankAccounts = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(function () {
    var storedCreditCard = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.creditCard);
    return storedCreditCard && JSON.parse(storedCreditCard) || [];
  }),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      creditCards = _react_1$default$useS4[0],
      setCreditCards = _react_1$default$useS4[1];

  (0, react_1.useEffect)(function () {
    if (!showMergeCartModal) {
      setNumberOfItems(0);
    }
  }, [showMergeCartModal]);
  (0, react_1.useEffect)(function () {
    setShoppingCart(Object.assign(Object.assign({}, shoppingCart), {
      purchaseOrderNumber: purchaseOrderNumber,
      discountCode: discountCode
    }));
  }, [purchaseOrderNumber, discountCode]);

  var ecommerceCleanup = function ecommerceCleanup() {
    if (checkoutType === Models_1.CheckOutType.CART && Object.keys(shippingAndBillingInformation || {}).length > 0) {
      resetAllCheckoutInformation();
    }

    if (checkoutType === Models_1.CheckOutType.QUOTE && Object.keys(quoteCart || {}).length > 0) {
      resetAllQuoteCheckoutInformation();
    }
  };

  (0, react_1.useEffect)(function () {
    return function () {
      ecommerceCleanup();
    };
  }, []);

  var resetAllCheckoutInformation = function resetAllCheckoutInformation() {
    setFlexibleDelivery(false);
    setShippingAndBillingInformation({});
    setCartPricingData({});
    setPurchaseOrderNumber("");
    setDiscountCode("");
    setIsCartDeliverable(true);
    setBankAccounts([]);
    setCreditCards([]);
    setCartDeliveryTimesData([]);
  };

  var resetAllQuoteCheckoutInformation = function resetAllQuoteCheckoutInformation() {
    setCheckoutType(Models_1.CheckOutType.CART);
    setQuoteCart({});
    setQuoteCartPricingData({});
    setQuoteId("");
    setQuoteShipToNumber("");
    setQuoteNameForCheckout("");
    setQuoteSourceForCheckout("");
    setQuoteListForCheckout({});
    setQuotePurchaseOrderNumber("");
    setBankAccounts([]);
    setCreditCards([]);
    setQuotePaymentInformation({});
  };
  /**
   * Provide an object that always contains a `state` property,
   * be it from the {@link defaultShipToAddress}, or from the {@link salesPlant }
   */


  var getStateAddress = function getStateAddress() {
    return !!Object.entries(defaultShipToAddress).length ? defaultShipToAddress : {
      state: salesPlant.state
    };
  };

  var getShipToAddresses = function getShipToAddresses() {
    axiosInstance.get("".concat(frontend_common_1.ApiUrl.ADDRESSES)).then(function (response) {
      var _a;

      if ((0, frontend_common_1.isAxiosError)(response) || response.status !== 200) {
        throw response;
      }

      var responseData = response.data; // Set all addresses to ShipToAddress (it may include Shipto, soldto and billto)

      if (!!responseData.addresses.length) {
        setShipToAddresses(_toConsumableArray(responseData.addresses));
      } // Filter all of ShipTo addresses


      var allShipToAddress = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.addresses) === null || _a === void 0 ? void 0 : _a.filter(function (address) {
        return address.addressCategory === common_enums_1.CommonShipmentEnum.AddressCategory.ShipTo;
      }); //find address that has default flag set to true

      var defaultShipToAddress = allShipToAddress === null || allShipToAddress === void 0 ? void 0 : allShipToAddress.find(function (address) {
        return address.default;
      }); // set default ship to address to address with default flag set to true or first address in the list

      var newDefaultShipToAddress = defaultShipToAddress || allShipToAddress[0];

      if (newDefaultShipToAddress) {
        setDefaultShipToAddress(newDefaultShipToAddress);
      } // find if current selectedShipTo is already among addresses,
      // if not, set selectedShipTo to newDefaultShipTo


      var selectedShipToAlreadyInList = allShipToAddress === null || allShipToAddress === void 0 ? void 0 : allShipToAddress.find(function (address) {
        return address.shipToNumber === (selectedShipToAddress === null || selectedShipToAddress === void 0 ? void 0 : selectedShipToAddress.shipToNumber);
      });

      if (!selectedShipToAlreadyInList && !!newDefaultShipToAddress) {
        setSelectedShipToAddress(newDefaultShipToAddress);
      } //set zipcode trigger based on previous state


      setZipCodeTrigger(function (prev) {
        return !prev;
      });
    }).catch(function (error) {
      console.error(error.message);
    });
  }; // Determine user zip code based on shipToAddresses


  var determineUserZipCode = function determineUserZipCode() {
    var zipCodeToBeSet = "";

    if (user.isLoggedIn) {
      var isRegisterUser = profile && profile.customer.customerNumber.length;

      if (isRegisterUser) {
        // register user zip code preference:
        // 1. Set zip code from selectedShipToAddress
        // 2. Set zip code from newDefaultShipToAddress
        // 3. Set zip code from profile
        if (selectedShipToAddress === null || selectedShipToAddress === void 0 ? void 0 : selectedShipToAddress.zipCode) {
          zipCodeToBeSet = (0, frontend_common_1.formatZipCode)(selectedShipToAddress.zipCode);
        } else if (defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.zipCode) {
          zipCodeToBeSet = (0, frontend_common_1.formatZipCode)(defaultShipToAddress.zipCode);
        }
      } else {
        // Guest user zip code preference:
        // 1. Session Storage.selectedShipToAddress.zipCode
        // 2. Session Storage.shipToAddresses.zipCode if addressCategory: "SoldTo"
        // 3. If no address found, then set zip code from profile for guest user
        if (selectedShipToAddress === null || selectedShipToAddress === void 0 ? void 0 : selectedShipToAddress.zipCode) {
          zipCodeToBeSet = (0, frontend_common_1.formatZipCode)(selectedShipToAddress.zipCode);
        } else {
          //When the user is a guest user and no shipToAddresses are found and user manually enters the zip code we need to persist the zip code and not override it with the profile zip code
          if (!zipCodeSystemUpdate && zipCode) {
            return;
          } //if no selectedShipToAddress, then set zip code from soldToAddress


          var soldToAddress = shipToAddresses.filter(function (address) {
            return address.addressCategory === common_enums_1.CommonShipmentEnum.AddressCategory.SoldTo;
          });

          if (soldToAddress.length > 0) {
            zipCodeToBeSet = (0, frontend_common_1.formatZipCode)(soldToAddress[0].zipCode);
          } else {
            setZipCodeFromUserProfile();
          }
        }
      }

      if (zipCodeToBeSet) {
        setZipCode(zipCodeToBeSet);
      } else {
        setZipCodeFromUserProfile();
      } //reset the zip code system update flag


      setZipCodeSystemUpdate(false);
    }
  };

  var setZipCodeFromUserProfile = function setZipCodeFromUserProfile() {
    var _a;

    var profileZip = (0, frontend_common_1.formatZipCode)((_a = profile === null || profile === void 0 ? void 0 : profile.customer) === null || _a === void 0 ? void 0 : _a.zip);

    if (!!profileZip) {
      setZipCode(profileZip);
    } else {
      //fall back to default zip code
      setZipCode(frontend_common_1.Default.ZIPCODE);
    }
  };

  var saveUserCartItems = function saveUserCartItems() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cookiesCartData, cartItems;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cookiesCartData = JSON.parse((0, frontend_common_1.getLocalStorageItem)(frontend_common_1.LocalItems.addToCart, []));
              cartItems = cookiesCartData.map(function (cartItem) {
                return Object.assign({
                  ryersonSku: cartItem.mm,
                  customerPartNumber: "",
                  quantity: cartItem.qty,
                  quantityUom: cartItem.quom,
                  pricingUom: cartItem.puom,
                  customerRefNumber: cartItem.crn || "",
                  purchaseOrderNumber: cartItem.po || "",
                  notes: cartItem.note || "",
                  domesticRequired: cartItem.domestic || false,
                  requestedDeliveryDate: cartItem.rdd || null
                }, cartItem.process && {
                  processing: {
                    process: cartItem.process.proc || "",
                    finish: cartItem.process.fnsh || "",
                    shape: cartItem.process.shp || "",
                    length: cartItem.process.len || null,
                    width: cartItem.process.wid || null,
                    outsideDiameter: cartItem.process.outsdDia || null,
                    insideDiameter: cartItem.process.insdDia || null,
                    toleranceMin: cartItem.process.tolMin || null,
                    toleranceMax: cartItem.process.tolMax || null,
                    toleranceMinInsideDiameter: cartItem.process.tolMinInsdDia || null,
                    toleranceMaxInsideDiameter: cartItem.process.tolMaxInsdDia || null
                  }
                });
              });
              _context.next = 4;
              return (0, AddToCart_1.addItemToCart)(axiosInstance, user.isLoggedIn, cartItems, function () {
                setShoppingCartData([]);
                setShowMergeCartModal(true);
                getUserCartItems();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var getUserCartItems = function getUserCartItems() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axiosInstance.get("".concat(frontend_common_1.ApiUrl.SHOPPING_CART)).then(function (response) {
                var responseData = response === null || response === void 0 ? void 0 : response.data;

                if (responseData) {
                  setShoppingCart(Object.assign({}, responseData));
                }
              }).catch(function (error) {
                console.error(error.message);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
  /**
   * add to cart api and set ShoppingCart state
   */


  var addToCart = function addToCart(axiosInstance, isLoggedIn, items, onFinish, onFailure) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, AddToCart_1.addItemToCart)(axiosInstance, isLoggedIn, items, function (response) {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return loadUserCartItems();

                        case 2:
                          onFinish && onFinish(response);
                          triggerAddToCartEvent(items);

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
              }, onFailure);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };
  /**
   * Use upon deleting/adding items to cart - similar to {@link loadUserCartItems}
   * except it doesn’t set state directly, it returns instead.
   *
   * check permissions - hide cart if no permission to view
   *
   * if user is logged in, get cart from api
   *
   * else - set cookies’ cart data to shoppingCart
   */


  var getUpdatedShoppingCart = function getUpdatedShoppingCart() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var response, cookiesCartData, mappedShoppingCartResponse;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (new common_permissions_1.UserPermission(user.token).has(common_permissions_1.Permission.Cart_View_Edit)) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return", {});

            case 4:
              if (!(user && user.isLoggedIn)) {
                _context5.next = 15;
                break;
              }

              _context5.next = 7;
              return axiosInstance.get("".concat(frontend_common_1.ApiUrl.SHOPPING_CART));

            case 7:
              response = _context5.sent;

              if (!((0, frontend_common_1.isAxiosError)(response) || (response === null || response === void 0 ? void 0 : response.status) !== 200)) {
                _context5.next = 12;
                break;
              }

              return _context5.abrupt("return", {});

            case 12:
              return _context5.abrupt("return", response.data);

            case 13:
              _context5.next = 18;
              break;

            case 15:
              cookiesCartData = JSON.parse((0, frontend_common_1.getLocalStorageItem)(frontend_common_1.LocalItems.addToCart, []));
              mappedShoppingCartResponse = {
                purchaseOrderNumber: purchaseOrderNumber,
                discountCode: discountCode,
                items: cookiesCartData === null || cookiesCartData === void 0 ? void 0 : cookiesCartData.map(mappers_1.intoCartItem)
              };
              return _context5.abrupt("return", mappedShoppingCartResponse);

            case 18:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  };

  var loadUserCartItems = function loadUserCartItems() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var cookiesCartData, UserPermissionUtil, newCartItems, mappedShoppingCartResponse;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              cookiesCartData = JSON.parse((0, frontend_common_1.getLocalStorageItem)(frontend_common_1.LocalItems.addToCart, []));
              UserPermissionUtil = new common_permissions_1.UserPermission(user.token);

              if (UserPermissionUtil.has(common_permissions_1.Permission.Cart_View_Edit)) {
                _context6.next = 5;
                break;
              }

              setShoppingCart({});
              return _context6.abrupt("return");

            case 5:
              if (!(user && user.isLoggedIn)) {
                _context6.next = 15;
                break;
              }

              setNumberOfItems(cookiesCartData.length);

              if (!(cookiesCartData.length > 0)) {
                _context6.next = 11;
                break;
              }

              saveUserCartItems();
              _context6.next = 13;
              break;

            case 11:
              _context6.next = 13;
              return getUserCartItems();

            case 13:
              _context6.next = 18;
              break;

            case 15:
              newCartItems = cookiesCartData === null || cookiesCartData === void 0 ? void 0 : cookiesCartData.map(mappers_1.intoCartItem);
              mappedShoppingCartResponse = {
                purchaseOrderNumber: purchaseOrderNumber,
                discountCode: discountCode,
                items: newCartItems
              };
              setShoppingCart(Object.assign({}, mappedShoppingCartResponse));

            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  };

  var getSalesPlant = function getSalesPlant(zipCode, shippingPlant) {
    var url = "".concat(frontend_common_1.ApiUrl.SALES_PLANT);

    if (zipCode === null || zipCode === void 0 ? void 0 : zipCode.length) {
      // only call the api if the zip code is in the correct format
      if (!(0, frontend_common_1.isPostalCodeInValidFormat)(zipCode)) {
        setIsValidZipCode(false);
        setSalesPlant({});
        return;
      }

      url = "".concat(url, "?zipCode=").concat(zipCode);
    }

    if (shippingPlant === null || shippingPlant === void 0 ? void 0 : shippingPlant.length) {
      url = "".concat(url, "?plant-number=").concat(shippingPlant);
    }

    axiosInstance.get("".concat(url)).then(function (response) {
      var responseData = response === null || response === void 0 ? void 0 : response.data;

      if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
        setSalesPlant(responseData);
      } else {
        setIsValidZipCode(false);
        setSalesPlant({});
      }
    }).catch(function () {
      setIsValidZipCode(false);
      setSalesPlant({});
    });
  }; //Trigger addToCart google analytics event


  var triggerAddToCartEvent = function triggerAddToCartEvent(items) {
    var addToCartGAEventParams = {
      items: items.map(function (item, index) {
        var ryersonSku = item.ryersonSku,
            quantity = item.quantity,
            quantityUom = item.quantityUom,
            customerPartNumber = item.customerPartNumber,
            category = item.category,
            form = item.form;
        return {
          item_id: ryersonSku,
          item_name: customerPartNumber || "",
          index: index,
          item_category: category,
          item_category2: form,
          item_variant: quantityUom,
          quantity: Number(quantity)
        };
      })
    };
    (0, frontend_common_1.sendGAEvent)(frontend_common_1.GoogleAnalyticsEventName.ADD_TO_CART, addToCartGAEventParams);
  }; //Trigger set user properties google analytics event


  var triggerSetUserPropertiesEvent = function triggerSetUserPropertiesEvent() {
    var setUserPropertiesGAEventParams = {
      isLoggedIn: user.isLoggedIn,
      country: localization.country,
      language: localization.language,
      hasAccount: !!(user === null || user === void 0 ? void 0 : user.account)
    };
    (0, frontend_common_1.setGAUserProperties)(setUserPropertiesGAEventParams);
  };

  (0, react_1.useEffect)(function () {
    setShoppingCart({});
    loadUserCartItems();

    if (user && !user.isLoggedIn) {
      setDefaultShipToAddress({});
      setShipToAddresses([]);
    }
  }, [user]);
  (0, react_1.useEffect)(function () {
    if (user && user.isLoggedIn && profile) {
      getShipToAddresses(); //TODO check swap account and call ship to address api
    }
  }, [profile]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.shipToAddresses, JSON.stringify(shipToAddresses));
  }, [shipToAddresses]);
  (0, react_1.useEffect)(function () {
    if (isMounted) {
      localStorage.setItem(frontend_common_1.SessionItems.defaultShipToAddress, JSON.stringify(defaultShipToAddress));
    }
  }, [defaultShipToAddress]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.selectedShipToAddress, JSON.stringify(selectedShipToAddress));
  }, [selectedShipToAddress]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.customerPickup, customerPickup.toString());
    shippingAndBillingInformation.shippingInformation && setShippingAndBillingInformation(Object.assign(Object.assign({}, shippingAndBillingInformation), {
      shippingInformation: Object.assign(Object.assign({}, shippingAndBillingInformation.shippingInformation), {
        carrierMethod: customerPickup ? "Customer Pick up" : "Standard Shipping"
      })
    }));
  }, [customerPickup]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.flexibleDelivery, flexibleDelivery.toString());
  }, [flexibleDelivery]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.orderConfirmationDetail, JSON.stringify(orderConfirmationDetail));
  }, [orderConfirmationDetail]);
  (0, react_1.useEffect)(function () {
    shippingAndBillingInformation && sessionStorage.setItem(frontend_common_1.SessionItems.shippingAndBillingInformation, JSON.stringify(shippingAndBillingInformation));
  }, [shippingAndBillingInformation]);
  (0, react_1.useEffect)(function () {
    cartPricingData && sessionStorage.setItem(frontend_common_1.SessionItems.cartPricingData, JSON.stringify(cartPricingData));
  }, [cartPricingData]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.purchaseOrderNumber, purchaseOrderNumber);
  }, [purchaseOrderNumber]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.discountCode, discountCode);
  }, [discountCode]); // As Non Logged In user or Guest User with/without shipto address

  (0, react_1.useEffect)(function () {
    if (isMounted && (!profile || profile && !profile.customer.customerNumber.length) && (zipCode === null || zipCode === void 0 ? void 0 : zipCode.length)) {
      getSalesPlant(zipCode);
    }
  }, [zipCode]); // As Register User Only

  (0, react_1.useEffect)(function () {
    if (isMounted && profile && (defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.shippingPlant)) {
      var shippingPlant = (0, frontend_common_1.formatZipCode)(defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.shippingPlant.toString());
      getSalesPlant("", shippingPlant);
    }
  }, [profile, defaultShipToAddress]);
  (0, react_1.useEffect)(function () {
    var isRegisterUser = profile && profile.customer.customerNumber.length;

    if (isMounted && Object.keys(salesPlant).length === 0) {
      getSalesPlant(!isRegisterUser || isGuestUser() ? zipCode : "");
    }
  }, [isMounted]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.salesPlant, JSON.stringify(salesPlant));

    if (!salesPlant || !Object.keys(salesPlant).length) {
      setIsValidZipCode(false);
    } else if ((isGuestUser() || !user.isLoggedIn) && !(salesPlant === null || salesPlant === void 0 ? void 0 : salesPlant.guestAccessAllowed)) {
      setIsValidZipCode(false);
    } else {
      setIsValidZipCode(true);
    }
  }, [salesPlant]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.isValidZipCode, isValidZipCode.toString());
  }, [isValidZipCode]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.isCartDeliverable, isCartDeliverable.toString());
  }, [isCartDeliverable]);
  (0, react_1.useEffect)(function () {
    if (!user.isLoggedIn) {
      if (shoppingCart === null || shoppingCart === void 0 ? void 0 : shoppingCart.items) {
        setShoppingCartData(_toConsumableArray(shoppingCart.items.map(AddToCart_1.mapToShortenedKeys)));
      }
    }
  }, [shoppingCart]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.checkoutType, checkoutType);
  }, [checkoutType]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.shipToAddressPage, shipToAddressPage);
  }, [shipToAddressPage]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.cartDeliveryTimesData, JSON.stringify(cartDeliveryTimesData));
  }, [cartDeliveryTimesData]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quoteShipToNumber, quoteShipToNumber);
  }, [quoteShipToNumber]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quoteId, quoteId);
  }, [quoteId]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quoteNameForCheckout, quoteNameForCheckout);
  }, [quoteNameForCheckout]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quoteSourceForCheckout, quoteSourceForCheckout);
  }, [quoteSourceForCheckout]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quoteCart, JSON.stringify(quoteCart));
  }, [quoteCart]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quoteCartPricingData, JSON.stringify(quoteCartPricingData));
  }, [quoteCartPricingData]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quoteListForCheckout, JSON.stringify(quoteListForCheckout));
  }, [quoteListForCheckout]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quotePurchaseOrderNumber, quotePurchaseOrderNumber);
  }, [quotePurchaseOrderNumber]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.quotePaymentInformation, JSON.stringify(quotePaymentInformation));
  }, [quotePaymentInformation]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.creditCard, JSON.stringify(creditCards));
  }, [creditCards]);
  (0, react_1.useEffect)(function () {
    sessionStorage.setItem(frontend_common_1.SessionItems.bankAccount, JSON.stringify(bankAccounts));
  }, [bankAccounts]);
  (0, react_1.useEffect)(function () {
    // This is for sending infotmation to LiveChat.
    var _a, _b, _c, _d;

    var lc = window.LiveChatWidget;

    if (lc) {
      lc.call("set_customer_name", (user === null || user === void 0 ? void 0 : user.firstName) && (user === null || user === void 0 ? void 0 : user.lastName) ? user.firstName + " " + user.lastName : "");
      lc.call("set_customer_email", (user === null || user === void 0 ? void 0 : user.email) || "");
      lc.call("update_session_variables", {
        zipCode: zipCode || "",
        country: (localization === null || localization === void 0 ? void 0 : localization.country) || "",
        language: (localization === null || localization === void 0 ? void 0 : localization.language) || "",
        account: (user === null || user === void 0 ? void 0 : user.account) || (salesPlant === null || salesPlant === void 0 ? void 0 : salesPlant.sapPlantNumber) + (salesPlant === null || salesPlant === void 0 ? void 0 : salesPlant.guestAccountNumber) || "",
        userName: (user === null || user === void 0 ? void 0 : user.userId) || "",
        roles: ((_b = (_a = user === null || user === void 0 ? void 0 : user.roles) === null || _a === void 0 ? void 0 : _a.filter(function (role) {
          return role !== "user";
        })) === null || _b === void 0 ? void 0 : _b.join(", ")) || "",
        isLoggedIn: (user === null || user === void 0 ? void 0 : user.isLoggedIn) || false,
        companyName: ((_c = profile === null || profile === void 0 ? void 0 : profile.company) === null || _c === void 0 ? void 0 : _c.companyName) || "",
        salesOffice: ((_d = profile === null || profile === void 0 ? void 0 : profile.customer) === null || _d === void 0 ? void 0 : _d.salesOffice) || "",
        salesPlant: (salesPlant === null || salesPlant === void 0 ? void 0 : salesPlant.name) || ""
      });
    }

    var gtag = window.gtag;

    if (gtag) {
      triggerSetUserPropertiesEvent();
    }
  }, [localization, user, profile, zipCode, salesPlant]);
  (0, react_1.useEffect)(function () {
    if (isMounted) {
      determineUserZipCode();
    }
  }, [zipCodeTrigger, selectedShipToAddress]);
  (0, react_1.useEffect)(function () {
    setIsMounted(true);
  }, []);
  var exposed = {
    cartPricingData: cartPricingData,
    customerPickup: customerPickup,
    shippingAndBillingInformation: shippingAndBillingInformation,
    defaultShipToAddress: defaultShipToAddress,
    searchAddedToCart: searchAddedToCart,
    setSearchAddedToCart: setSearchAddedToCart,
    shipToAddresses: shipToAddresses,
    shoppingCartData: shoppingCartData,
    setShoppingCartData: setShoppingCartData,
    shoppingCart: shoppingCart,
    setShoppingCart: setShoppingCart,
    setCartPricingData: setCartPricingData,
    setCustomerPickup: setCustomerPickup,
    setShippingAndBillingInformation: setShippingAndBillingInformation,
    setDefaultShipToAddress: setDefaultShipToAddress,
    addToCart: addToCart,
    setShipToAddresses: setShipToAddresses,
    flexibleDelivery: flexibleDelivery,
    setFlexibleDelivery: setFlexibleDelivery,
    resetAllCheckoutInformation: resetAllCheckoutInformation,
    orderConfirmationDetail: orderConfirmationDetail,
    setOrderConfirmationDetail: setOrderConfirmationDetail,
    purchaseOrderNumber: purchaseOrderNumber,
    setPurchaseOrderNumber: setPurchaseOrderNumber,
    discountCode: discountCode,
    setDiscountCode: setDiscountCode,
    loadUserCartItems: loadUserCartItems,
    getUpdatedShoppingCart: getUpdatedShoppingCart,
    salesPlant: salesPlant,
    isValidZipCode: isValidZipCode,
    numberOfItems: numberOfItems,
    showMergeCartModal: showMergeCartModal,
    setShowMergeCartModal: setShowMergeCartModal,
    isCartDeliverable: isCartDeliverable,
    setIsCartDeliverable: setIsCartDeliverable,
    checkoutType: checkoutType,
    setCheckoutType: setCheckoutType,
    shipToAddressPage: shipToAddressPage,
    setShipToAddressPage: setShipToAddressPage,
    cartDeliveryTimesData: cartDeliveryTimesData,
    setCartDeliveryTimesData: setCartDeliveryTimesData,
    quoteShipToNumber: quoteShipToNumber,
    setQuoteShipToNumber: setQuoteShipToNumber,
    quoteId: quoteId,
    setQuoteId: setQuoteId,
    quoteNameForCheckout: quoteNameForCheckout,
    setQuoteNameForCheckout: setQuoteNameForCheckout,
    quoteSourceForCheckout: quoteSourceForCheckout,
    setQuoteSourceForCheckout: setQuoteSourceForCheckout,
    quoteCart: quoteCart,
    setQuoteCart: setQuoteCart,
    quoteCartPricingData: quoteCartPricingData,
    setQuoteCartPricingData: setQuoteCartPricingData,
    quoteListForCheckout: quoteListForCheckout,
    setQuoteListForCheckout: setQuoteListForCheckout,
    resetAllQuoteCheckoutInformation: resetAllQuoteCheckoutInformation,
    getStateAddress: getStateAddress,
    quotePurchaseOrderNumber: quotePurchaseOrderNumber,
    setQuotePurchaseOrderNumber: setQuotePurchaseOrderNumber,
    quotePaymentInformation: quotePaymentInformation,
    setQuotePaymentInformation: setQuotePaymentInformation,
    bankAccounts: bankAccounts,
    setBankAccounts: setBankAccounts,
    creditCards: creditCards,
    setCreditCards: setCreditCards,
    selectedShipToAddress: selectedShipToAddress,
    setSelectedShipToAddress: setSelectedShipToAddress,
    getShipToAddresses: getShipToAddresses,
    addItemToCart: AddToCart_1.addItemToCart
  };
  return (0, jsx_runtime_1.jsx)(EcommerceContext.Provider, {
    value: exposed,
    children: children
  });
};

exports.EcommerceProvider = EcommerceProvider;
exports.default = EcommerceContext;

function useEcommerce() {
  return react_1.default.useContext(EcommerceContext);
}

exports.useEcommerce = useEcommerce;